import { ReactChild } from "react";
import IconDiscard from "../../icons/icon-discard/icon-discard";
import { ButtonIcon } from "../../inputs/button-icon/button-icon";
import { Button, IButtonProps } from "../../inputs/button/button";
import { Modal } from "../modal";

import './default-modal-layout.scss';

interface IDefaultModalLayoutModalProps {
    children: ReactChild;
    isCloseDisabled: boolean;
    onCloseClicked: () => void;
    buttons?: IButtonProps[];
    headerContent?: ReactChild;
}

export const DefaultModalLayout: React.FC<IDefaultModalLayoutModalProps> = ({ children, isCloseDisabled, onCloseClicked, buttons, headerContent }) => {
    const IconDiscardGrey = () => (<IconDiscard color="var(--color-neutral-3)" />);

    return (
        <Modal onCloseClicked={() => !isCloseDisabled && onCloseClicked()}>
            <div className="modal-content">
                {headerContent && <div className="modal-header-content">{headerContent}</div>}
                {!isCloseDisabled &&
                    <div className="modal-close-button">
                        <ButtonIcon Component={IconDiscardGrey} onClick={onCloseClicked} />
                    </div>
                }
                {children}
                {!!buttons && <div className="modal-buttons">
                    {buttons.map((props, i) => (
                        <Button
                            key={i}
                            {...props}
                        />
                    ))}
                </div>
                }
            </div>
        </Modal>
    );
}
